<template>
    <header id="head" class="wrapper--head">
        <div class="wrapper--logo">
            <Logo ref="logo" v-bind="{ tabindex }" />
        </div>

        <CornerButtons 
            :visible="hasCtaButton"
            :tabindex="tabindex"
        />

        <HamburgerButton
            id="mainMenuBtn"
            aria-haspopup="true"
            v-bind="{ menuOpened, submenuOpened, tabindex }"
        />
    </header>
</template>

<script>
import { mapState } from 'vuex'
import HamburgerButton from '@/components/Ui/HamburgerButton'

export default {
    components: {
        HamburgerButton,
        CornerButtons: () => import(/* webpackChunkName: "ui-corner-btn" */ '@/components/Discover/CornerButtons'),
    },
    computed: {
        hasCtaButton() {
            const { path } = this.$route
            const isDiscover = path.startsWith('/discover-')

            return isDiscover
        },
        tabindex() {
            const { visible } = this.$store.state
            if ( visible.stories ) {
                return -1
            }
            return undefined
        },
        ...mapState({
            menuOpened: state => state.menu.opened,
            submenuOpened: state => state.menu.submenu,
        }),
    },
}
</script>